import React from 'react';
import { IconProps } from '@/models/IconProps';

const Cart: React.FC<IconProps> = ({ height = '24', width = '24', strokeColor = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon">
        <g id="icon">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 3.25C2.58579 3.25 2.25 3.58579 2.25 4C2.25 4.41421 2.58579 4.75 3 4.75C3.81705 4.75 4.52448 5.31748 4.70172 6.11507L5.13165 8.04975C5.13477 8.09674 5.14235 8.14372 5.15449 8.19008L5.20944 8.39979L5.26786 8.6627C5.27935 8.7144 5.29592 8.76366 5.31693 8.81006L6.9921 15.2039C7.53947 17.293 9.42732 18.75 11.587 18.75H16.7506C19.3739 18.75 21.5006 16.6234 21.5006 14V11.2907C21.5006 10.7268 21.4193 10.0465 21.0367 9.44622C20.1758 8.0956 18.674 7.25 17.0314 7.25H6.49052L6.166 5.78968C5.83625 4.30578 4.5201 3.25 3 3.25ZM8.44313 14.8237L6.85182 8.75H17.0314C18.1549 8.75 19.1827 9.32834 19.7718 10.2525C19.931 10.5023 20.0006 10.8465 20.0006 11.2907V14C20.0006 15.7949 18.5455 17.25 16.7506 17.25H11.587C10.1093 17.25 8.81764 16.2531 8.44313 14.8237Z"
            fill={strokeColor}
          />
          <path
            d="M17 22C17.5523 22 18 21.5523 18 21C18 20.4477 17.5523 20 17 20C16.4477 20 16 20.4477 16 21C16 21.5523 16.4477 22 17 22Z"
            fill={strokeColor}
          />
          <path
            d="M10 21C10 21.5523 9.55228 22 9 22C8.44772 22 8 21.5523 8 21C8 20.4477 8.44772 20 9 20C9.55228 20 10 20.4477 10 21Z"
            fill={strokeColor}
          />
        </g>
      </g>
    </svg>
  );
};

export default Cart;
